/* TODO

=== BUGS ===
Viewing purchase order shouldn't change date, orderBy created
Receiving items should not make it 'approved'
seenBy shouldn't add if already present
Editing non-price related things in 'pending' shouldn't warn about price.
Editing non-price related things in approved should change confirm message if over escalation threshold.
Editing non-price related things in approved should require re-approval from branch manager.

=== AFTER LAUNCH/LONG-TERM ===
Re-do seenBy
Moving item from received to not all items received should warn user with confirm dialog
Limit spend date filter to 2 year max window
Cost centre categories/sub-categories
Export PDF of approved POs
File upload
Mobile support
*/

import React from 'react'
import { BrowserRouter as Router } from 'react-router-dom'
import SessionLoaded from './components/SessionLoaded'
import Layout from './components/Layout'
import Theme from './components/Theme'
import Routes from './components/Routes'

import './App.scss'

import { SessionProvider, sessionReducer } from './context/session'

const App = () => {

  const [state, dispatch] = React.useReducer(sessionReducer, { user: null })
  const { user } = state;

  return (
    <Theme>
      <Router>
        <SessionProvider value={{ state, dispatch }}>
          <SessionLoaded>
            <Layout user={user}>
              <Routes />
            </Layout>
          </SessionLoaded>
        </SessionProvider>
      </Router>
    </Theme>
  )

}

export default App
